import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCommentOutline16 = function SvgCommentOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.635 12.296.074-.222-.122-.198A7.384 7.384 0 0 1 .5 8C.5 3.865 3.865.5 8 .5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5a7.469 7.469 0 0 1-3.704-.98l-.183-.105-.203.058-3.319.947 1.044-3.124z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.571 5.714h6.857M4.571 8h6.857m-6.857 2.286h6.857",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
};

var CommentOutline16Svg = SvgCommentOutline16;

export { CommentOutline16Svg as default };
//# sourceMappingURL=CommentOutline16.svg.js.map
